<template>
  <div style="position: relative;">
    <el-form ref="teachingPointFilter" :model="teachingPointList" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="教学点名称" prop="formFilter.pointName">
          <el-input class="filter-item" v-model="teachingPointList.formFilter.pointName"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="位置" prop="formFilter.location">
          <el-input class="filter-item" v-model="teachingPointList.formFilter.location"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetTeachingPoint">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshTeachingPoint(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('teachingPoint:all')"
                   @click="onTeachingPointAddClick()">
          新增
        </el-button>
        <el-button slot="operator" type="success" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('teachingPoint:all')"
                   @click="onImportClick()">
          导入
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="teachingPoint" :data="teachingPointList.TeachingPoint.impl.dataList" :size="defaultFormItemSize" @sort-change="teachingPointList.TeachingPoint.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="teachingPointList.TeachingPoint.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="teachingPointList.TeachingPoint.impl.getTableIndex" />
          <el-table-column label="教学点名称" prop="pointName" sortable="custom">
          </el-table-column>
          <el-table-column label="位置" prop="location" sortable="custom">
          </el-table-column>
          <el-table-column label="经度" prop="longitude" sortable="custom">
          </el-table-column>
          <el-table-column label="纬度" prop="latitude" sortable="custom">
          </el-table-column>
          <el-table-column label="备注" prop="remark" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" sortable="custom" width="180px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150px">
            <template slot-scope="scope">
              <el-button @click.stop="onTeachingPointEditClick(scope.row)" type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('teachingPoint:all')">
                编辑
              </el-button>
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('teachingPoint:all')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="teachingPointList.TeachingPoint.impl.totalCount"
            :current-page="teachingPointList.TeachingPoint.impl.currentPage"
            :page-size="teachingPointList.TeachingPoint.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="teachingPointList.TeachingPoint.impl.onCurrentPageChange"
            @size-change="teachingPointList.TeachingPoint.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>

    <!-- 导入弹窗 -->
    <el-dialog title="导入教学点信息" :visible.sync="teachingPointList.importDialogVisible" width="500px" :close-on-click-modal="false"
               :close-on-press-escape="false"
    >
      <el-upload
        ref="upload"
        :auto-upload="false"
        :on-change="onFileChange"
        :file-list="teachingPointList.fileList"
        accept=".xlsx,.xls"
        drag
        :limit="1"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅支持xlsx/xls格式文件，且不超过10MB</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button :size="defaultFormItemSize" @click="teachingPointList.importDialogVisible = false">取消</el-button>
        <el-button type="primary" :size="defaultFormItemSize" :loading="teachingPointList.isImporting" @click="onImportSubmitClick">确定导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters } from 'vuex';
import { findItemFromList } from '@/utils';
// eslint-disable-next-line no-unused-vars
import rules from '@/utils/validate.js';
import { TableWidget } from '@/utils/widget.js';
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
import { TeachingPointController } from '@/api';

export default {
  name: 'teachingPointList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      teachingPointList: {
        formFilter: {
          pointName: undefined,
          location: undefined
        },
        formFilterCopy: {
          pointName: undefined,
          location: undefined
        },
        TeachingPoint: {
          impl: new TableWidget(this.loadTeachingPointWidgetData, this.loadTeachingPointVerify, true, true)
        },
        importDialogVisible: false,
        isImporting: false,
        fileList: [],
        isInit: false
      }
    }
  },
  methods: {
    onResetTeachingPoint () {
      this.$refs.teachingPointFilter.resetFields();
      this.refreshTeachingPoint(true);
    },
    loadTeachingPointWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        teachingPointDtoFilter: {
          pointName: this.teachingPointList.formFilterCopy.pointName,
          location: this.teachingPointList.formFilterCopy.location
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        TeachingPointController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          if (this.teachingPointList.TeachingPoint.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.teachingPointList.TeachingPoint.impl.currentRow.id, 'id');
              this.$refs.teachingPoint.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadTeachingPointVerify (data) {
      return true;
    },
    refreshTeachingPoint (resetPage) {
      this.teachingPointList.formFilterCopy = JSON.parse(JSON.stringify(this.teachingPointList.formFilter));
      if (resetPage) {
        this.teachingPointList.TeachingPoint.impl.refreshTable(true, 1);
      } else {
        this.teachingPointList.TeachingPoint.impl.refreshTable();
      }
      if (!this.teachingPointList.isInit) {
        // 初始化下拉数据
      }
      this.teachingPointList.isInit = true;
    },
    onTeachingPointAddClick () {
      let params = {
        mode: 'add',
        closeVisible: 1
      };
      this.$router.push({name: 'teachingPointForm', query: params});
    },
    onTeachingPointEditClick (row) {
      let params = {
        id: row.id
      };
      params.closeVisible = 1;
      this.$router.push({name: 'teachingPointForm', query: params});
    },
    onDeleteClick (row) {
      this.$confirm('确定要删除该教学点信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        TeachingPointController.delete(this, { id: row.id }).then(res => {
          this.$message.success('删除成功');
          this.refreshTeachingPoint(false);
        }).catch(e => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    onImportClick () {
      this.teachingPointList.fileList = [];
      this.teachingPointList.importDialogVisible = true;
    },
    onFileChange (file, fileList) {
      this.teachingPointList.fileList = fileList.slice(-1);
    },
    onImportSubmitClick () {
      if (this.teachingPointList.fileList.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.teachingPointList.isImporting = true;
      let formData = new FormData();
      formData.append('file', this.teachingPointList.fileList[0].raw);
      TeachingPointController.importData(this, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.success) {
          let data = res.data;
          this.$message.success(`导入完成：成功${data.successCount}条，失败${data.failCount}条`);
          if (data.failMessages && data.failMessages.length > 0) {
            this.$alert(data.failMessages.join('<br/>'), '导入失败详情', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定'
            });
          }
          this.teachingPointList.importDialogVisible = false;
          this.refreshTeachingPoint(true);
        } else {
          this.$message.error(res.message);
        }
      }).catch(e => {
        this.$message.error('导入失败');
      }).finally(() => {
        this.teachingPointList.isImporting = false;
      });
    },
    onResume () {
      this.refreshTeachingPoint();
    },
    formInit () {
      this.refreshTeachingPoint();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style scoped>
</style>
